// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.main-container {
  padding: 24px 32px;
  font-family: "Gotham", Arial, sans-serif;
}

.top-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top-container #title {
  font-size: large;
  font-family: "GothamBold", Arial, sans-serif;
}
.top-container .close-btn {
  border: none;
  background: none;
  cursor: pointer;
  color: #707070;
}

.draft-info-message {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #e3f2fd;
  border-left: 4px solid #0066b2;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  color: #0b2d71;
  border-radius: 2px;
}
.draft-info-message .info-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: #0066b2;
  flex-shrink: 0;
}

.modal-content {
  display: flex;
  flex-direction: column;
  border: none;
}
.modal-content ::ng-deep .mat-form-field-outline {
  color: #e3e3e3;
}

.form-field {
  display: flex;
  flex-direction: column;
}
.form-field .field-label {
  font-size: 13px;
  color: #707070;
  font-family: "Gotham", Arial, sans-serif;
  margin-bottom: 4px;
}
.form-field .full-width {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 16px;
}
.form-row .half-width {
  flex: 1;
}

.full-width {
  width: 100%;
}

.clone-error {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #e21836;
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  margin-top: 8px;
}
.clone-error .error-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: middle;
}

.progress-bar-container {
  margin: 8px 0;
}

.lower-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 16px;
}
.lower-container .btn-divider {
  width: 8px;
}
.lower-container .secondary {
  background: none;
  border: 1px solid #8c8f93;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  color: #707070;
}
.lower-container .secondary:hover {
  background-color: #e3e3e3;
}
.lower-container .button {
  background-color: #0066b2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
}
.lower-container .button:disabled {
  background-color: #8c8f93;
  cursor: not-allowed;
}
.lower-container .button:hover:not(:disabled) {
  background-color: #0b2d71;
}

.clone-warning {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #e5601f;
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  margin-top: 4px;
}
.clone-warning .warning-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: middle;
}

.inline-label-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
}

.release-hint {
  font-size: 12px;
  color: #707070;
  margin: 4px 0 0;
  font-family: "Gotham", Arial, sans-serif;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
